import { render } from "./BuildApp.vue?vue&type=template&id=6e4b52ab"
import script from "./BuildApp.vue?vue&type=script&lang=js"
export * from "./BuildApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__